/* eslint-disable no-console */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { CheckOutlined } from '@ant-design/icons'
import { Button, Col, Form, message, Row, Select, Spin } from 'antd'
import { PaymentElement, useElements, useStripe } from '@stripe/react-stripe-js'
import React, { PropsWithChildren } from 'react'
import { CustomForm } from '../UserDetailForm/UserDetailForm.styles'
import { useAppSelector } from '../../../store/hooks'
import { BASE_URL } from '../../../utils/consts'

const { Option } = Select

const formItemLayout = {
    wrapperCol: {
        lg: { span: 24 },
    },
}

interface PropsType {
    isLoading: boolean
    setIsLoading: (status: boolean) => void
}

const PaymentForm = ({
    isLoading,
    setIsLoading,
}: PropsWithChildren<PropsType>): JSX.Element => {
    const stripe = useStripe()
    const elements = useElements()

    const user = useAppSelector((state) => state.user!)

    const handleSubmit = async () => {
        if (!stripe || !elements) {
            return
        }
        setIsLoading(true)
        try {
            const result = await stripe.confirmPayment({
                // `Elements` instance that was used to create the Payment Element
                elements,
                confirmParams: {
                    return_url: `${BASE_URL}/profile`,
                },
            })

            if (result.error) {
                message.error(
                    `An unexpected error occurred. ${result.error.message}`
                )
            } else {
                console.log(result)
            }
        } catch (error) {
            message.info(`Something went wrong. Please try again`)
            window.location.reload()
        } finally {
            setIsLoading(false)
        }
    }

    return (
        <Spin spinning={isLoading}>
            <CustomForm
                onFinish={handleSubmit}
                {...formItemLayout}
                initialValues={{
                    paymentType: 'card',
                }}
            >
                <Row>
                    <Col span={23}>
                        <Form.Item
                            name="paymentType"
                            hasFeedback
                            rules={[
                                {
                                    required: true,
                                    message: 'Please select your payment!',
                                },
                            ]}
                            style={{ paddingTop: '16px' }}
                        >
                            <Select
                                placeholder="Please select a payment"
                                style={{ borderRadius: 7 }}
                            >
                                <Option value="card">Credit Debit Card</Option>
                            </Select>
                        </Form.Item>
                    </Col>
                </Row>
                {elements && <PaymentElement id="payment-element" />}
                <Row>
                    <Col span={23}>
                        <div className="notify">
                            <p>
                                By purchasing a license to use InnovationX you
                                have access to all of your projects and the
                                ability to export your projects at anytime
                                subscription is active. If you cancel your
                                subscription you will still have access to your
                                projects, but will no longer be able to export
                                any material.
                            </p>
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col span={23}>
                        <div className="planBtn">
                            <Button
                                disabled={user.subscribed}
                                htmlType="submit"
                                shape="round"
                                icon={<CheckOutlined />}
                                style={{ width: '100%' }}
                            >
                                Finish your purchase
                            </Button>
                        </div>
                    </Col>
                </Row>
            </CustomForm>
        </Spin>
    )
}

export default PaymentForm
